import type { ReactElement } from 'react';
import { renderToString } from 'react-dom/server';

const getSvgDataUrl = (svgString: string): string =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;

export const createGoogleMapIcon = (iconComponent: ReactElement) => {
  const svgString = renderToString(iconComponent);
  const url = getSvgDataUrl(svgString);

  return { url };
};
